module.exports = __webpack_public_path__ + "static/media/scratch-off-nfc-combo.832dd196.svg";